'use strict';

exports.__esModule = true;
exports.sanitizeUrl = sanitizeUrl;

var _consts = require('../consts/consts');

/**
 * Sanitizes the given URL by leaving only supported query params.
 *
 * @param {String} url to sanitize
 */
function sanitizeUrl(url) {
  if (typeof url === 'string') {
    var queryIndex = url.indexOf(_consts.QUERY_SEPARATOR);
    if (queryIndex !== -1) {
      var _url$split = url.split(_consts.QUERY_SEPARATOR),
          urlWithoutQuery = _url$split[0],
          query = _url$split[1];

      var sanitizedQuery = query.split(_consts.QUERY_PARAM_SEPARATOR).filter(function (pair) {
        return _consts.QUERY_WHITELIST.some(function (key) {
          return pair.startsWith(key);
        });
      }).join(_consts.QUERY_PARAM_SEPARATOR);
      if (sanitizedQuery) {
        return '' + urlWithoutQuery + _consts.QUERY_SEPARATOR + sanitizedQuery;
      }
      return urlWithoutQuery;
    }
    return url;
  }
  return undefined;
}